module.exports = __webpack_public_path__ + "static/img/logo.939b53b8.svg";